import _ from 'lodash';
import templateStr from 'text!./templates/vehicle-incident.html';

export default ['TranslateService', 'LocaleService', (TranslateService, LocaleService) => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            vehicleIncident: '=',
            index: '=?'
        },
        controller: ['$scope', ($scope) => {
            $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');
            const newVehicle = {
                placeholder: true
            };
            const newPassenger = {
                placeholder: true
            };
           
            $scope.$watch('vehicleIncident.driver.value', (newValue, oldValue) => {
                if (newValue !== oldValue && newValue && newValue.placeholder) {
                    $scope.vehicleIncident.value.setNewDriver();
                }
            });

            $scope.$watch('vehicleIncident.vehicle.value', (newValue, oldValue) => {
                if (newValue !== oldValue && newValue && newValue.placeholder) {
                    $scope.vehicleIncident.value.setNewVehicle();
                }
            });

            $scope.contactName = (contact) => {
                return contact.placeholder ?
                    TranslateService.instant('fnol.pa.directives.vehicle-incident.Other Driver') :
                    contact.getDisplayName(TranslateService.instant('fnol.pa.directives.vehicle-incident.New Driver'));
            };

            $scope.vehicleName = (vehicle) => {
                return vehicle.placeholder ?
                    TranslateService.instant('fnol.pa.directives.vehicle-incident.Other Vehicle') :
                    vehicle.getDisplayName(TranslateService.instant('fnol.pa.directives.vehicle-incident.New Vehicle'));
            };

            $scope.getAvailableVehicles = () => {
                const result = $scope.vehicleIncident.value.availableVehicles();
                result.push(newVehicle);
                // if there is a new vehicle added pass it in to list of available vehicles 
                if ($scope.vehicleIncident.value.vehicle && !result.includes($scope.vehicleIncident.value.vehicle)) {
                    result.push($scope.vehicleIncident.value.vehicle);
                }
                return result;
            };

            $scope.getAvailableDrivers = () => {
                const result = $scope.vehicleIncident.value.availableDrivers();
                result.push(newPassenger);
                return result;
            };

            $scope.getAvailablePassengers = () => {
                return _.filter($scope.vehicleIncident.value.availablePassengers());
            };

            $scope.addPassenger = (passengerContact, $event) => {
                $scope.vehicleIncident.value.addPassenger(passengerContact);
                $event.preventDefault();
            };

            $scope.removePassenger = (passengerContact) => {
                let removeIdx;
                _.find($scope.vehicleIncident.passengers.value, (tableContact, index) => {
                    const matched = tableContact === passengerContact ||
                        tableContact.publicID === passengerContact.publicID;
                    removeIdx = (matched) ? index : -1;
                    return matched;
                });
                $scope.vehicleIncident.passengers.value.splice(removeIdx, 1);
            };
        }],

        link: (scope /* , element, attrs, Ctrl*/) => {
            scope.TranslateService = TranslateService;
        }
    };
}];